import React from 'react';
import { IconWrapper } from '../../common/IconWrapper';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

export default function SupplierMinimumOrderQuantity({ singleMoq, division }) {
    const inError =
        singleMoq.submittedCases < singleMoq.minimumOrderQtyNoSurcharge || singleMoq.errorMessages.length > 0;

    return (
        <div className={'supplier-moq-wrapper'}>
            <div className={'case-summary'}>
                <span>You have ordered </span>
                <strong className={inError ? 'error' : 'success'}>
                    {singleMoq.submittedCases}/{singleMoq.minimumOrderQtyNoSurcharge}
                </strong>
                <span> {division} cases.</span>
            </div>
            <ul className={'fa-ul'}>
                {singleMoq.errorMessages.map((message, index) => (
                    <li key={index}>
                        <span className="fa-li error">
                            <IconWrapper icon={faExclamationCircle} />
                        </span>
                        {message}
                    </li>
                ))}
                {singleMoq.infoMessages.map((message, index) => (
                    <li key={index}>
                        <span className="fa-li success">
                            <IconWrapper icon={faCheckCircle} />
                        </span>
                        {message}
                    </li>
                ))}
            </ul>
        </div>
    );
}
